import { EuiLink } from "@inscopix/ideas-eui";
import { Tour } from "../TourProvider.types";

export const TourNewVersionIntro_25_2: Tour = {
  name: "Welcome to IDEAS!",
  pages: ["home", "organizationProjects", "projectHome"],
  conditions: {},
  options: {
    dismissButton: true,
  },
  description:
    "Get introduced to some of the key features and capabilities of the platform",
  steps: [
    {
      anchorId: "header-tours-button",
      title: "Welcome to IDEAS!",
      content:
        "IDEAS is built for managing and analyzing neuroscience research data, with a focus on reproducibility, scalability, traceability, and usability. Click next to learn about some of the key features, or dismiss for now & start this guide from the menu above at your convenience.",
    },
    {
      anchorId: "header-tours-button",
      title: "Projects",
      content:
        "Projects are where you can upload and organize related data, set up batch processing & analysis tasks, and securely collaborate and share with others.",
    },
    {
      anchorId: "header-tours-button",
      title: "Data Tables",
      content: (
        <span>
          Flexibly organize your uploaded data into custom data tables. Leverage
          the power of spreadsheets with the scalability of cloud storage to
          effortlessly organize and browse terabytes of data files and
          associated metadata and figures. Link related data together, and group
          data in different ways to help power your analysis workflows.{" "}
          <EuiLink
            href="https://inscopix.github.io/ideas-docs/link-join-table.html"
            target="_blank"
          >
            Read more on how to best leverage data tables for your work.
          </EuiLink>
        </span>
      ),
    },
    {
      anchorId: "header-tours-button",
      title: "Analyzing your data",
      content: (
        <span>
          Setting up batch processing and analysis tasks is easy! In a few
          steps, you can now specific which data table columns to use for
          specific analysis input parameters, drastically reducing the
          &apos;number of clicks&apos; required to select the right input data
          for each task. You can also set your own default values, and specify
          computing requirements. IDEAS takes care of all the cloud computing
          orchestration.{" "}
          <EuiLink
            href="https://inscopix.github.io/ideas-docs/analyze-data.html"
            target="_blank"
          >
            Read more about the new Analysis Table experience.
          </EuiLink>
        </span>
      ),
    },
    {
      anchorId: "header-tours-button",
      title: "Organizing your Data and Analysis Tables",
      content:
        "You can organize related data and analysis tables in Folders on the Project homepage. You can also sort your tables according to different properties (name, type, created, modified) and can easily filter to view only data or analysis tables by clicking on the toggle button to the right of the search bar.",
    },
    {
      anchorId: "header-tours-button",
      title: "Feature tour guides",
      content:
        "To help introduce the new features we’ve built tour guides, accessible through the “Guides” button here, that help walk through specific features available on different pages. Look for these guides as you navigate around IDEAS to learn more about what actions you can take!",
    },
    {
      anchorId: "header-tours-button",
      title: "Learn more!",
      content: (
        <span>
          To learn more about all the new features in the latest release,{" "}
          <EuiLink
            href="https://inscopix.github.io/ideas-docs/index.html"
            target="_blank"
          >
            check out our user docs!
          </EuiLink>
        </span>
      ),
    },
  ],
};
